import React from "react";
import {Helmet} from "react-helmet";
import FAC from "../../assets/images/force_and_cheat.jpg";

export default function ForceAndFraud() {
    return (
        <div>
            <Helmet>
                <title>力与诈 Force And Fraud</title>
            </Helmet>
            <h6 className="App-essay-title">力与诈</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 六月</b>
                <br/><br/>
                秦襄公从周天子手中完成了“独立战争”，秦人第一次有了自己的国家。
                <br/><br/>
                往后五百年，环境艰苦，秦人为了生存，迷信两种力量：压倒性的武力，和反复无常的欺诈。
                <br/><br/>
                通过一系列有力措施，秦人把“力与诈”发挥到极致。郑国、商鞅、张仪、范雎、李斯……天下人才被秦国吸引，来到秦地。他们开凿运河，强壮兵马，变法革新，破纵连横。
                <br/><br/>
                这些人是秦国百年科技进步和军事革命的发动机，他们把国力推向前所未有的高度。功成名就后，不少功臣们被自己崇拜的“力与诈”害死。
                <br/><br/>
                天下统一，秦王把“王”更名为“皇”：一种更“大”的王。胡人不敢南下而牧马，士不敢弯弓而报怨。秦王政武力如日中天，统一后帝国在短短二十年间土崩瓦解。
                <br/><br/>
                这场崩溃深深震撼了古代中国人。扒开现代中国人的皮，你会看到鸦片战争；扒开古代中国人的皮，你会看到秦帝国的崩溃。
                <br/><br/>
                世界是个巨大的圆，如果朝左走得够远，就会遇到朝右走得够远的同伴。再相逢时，大家甚至会忘记曾在原点分道扬镳过。兵戎相见，然后分道扬镳。
                <br/><br/>
                图文无关。
                <br/><br/>
                <img src={FAC} alt="" width={"100%"}/>

            </p>

            <br/>

            <h6 className="App-essay-title">Force And Fraud</h6>
            <p className="App-essay-article">
                <br/>
                <b>Jun 2025</b>
                <br/><br/>

            </p>
        </div>)
}
